import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Column, Row, VideoModal, Carousel } from '@pella/sash-framework';
import { Image, CTA, Video } from '../../..';

const InstallInstructions = ({ data, className }) => {
	const [modal, setModal] = useState('');

	const onModalTrigger = (value) => setModal(value);

	const renderTableColumn = (column) => (
		<div className='installInstructions-col w-1/3 lg:w-28 lg:text-center'>
			{column?.link?.title && <CTA data={column} />}
			{column?.video?.video_id && (
				<>
					<button
						aria-label={column.video.title}
						onClick={() => onModalTrigger(column.video.video_id)}
						className='text-black underline decoration-current hover:no-underline'
					>
						{column.video.button_title}
					</button>

					<VideoModal
						isOpen={column.video.video_id === modal}
						onClose={() => onModalTrigger('')}
						videoId={column.video.video_id}
						transcript={column.transcript}
						title={column.video.title}
					/>
				</>
			)}
		</div>
	);

	return (
		<div className={`installInstructions${className || ''}`}>
			<Row verticalGutters>
				{data?.demo_assets?.[0] && (
					<Column
						xs={12}
						md={5}
						xl={4}
					>
						<Carousel showDots>
							{data.demo_assets.map((item, index) => (
								<>
									{item.image?.url && (
										<Image
											data={item}
											key={index}
											className='!block h-full w-full [&_img]:!object-contain'
										/>
									)}

									{item.video?.video_id && (
										<Video
											data={item}
											key={index}
										/>
									)}
								</>
							))}
						</Carousel>
					</Column>
				)}

				<Column
					xs={12}
					md='fluid'
				>
					{data?.heading && <h3 dangerouslySetInnerHTML={{ __html: data.heading }} />}

					{data?.description && (
						<div
							dangerouslySetInnerHTML={{ __html: data.description }}
							className='mb-7 max-w-[80ch]'
						/>
					)}

					{data?.table?.[0] &&
						data.table.map((table, index) => (
							<div
								key={`table-${index}`}
								className={`installInstructions-table ${index > 0 ? 'mt-6' : ''}`}
							>
								{table.table_heading && <h4 className='text-subtitle-2 mb-2'>{table.table_heading}</h4>}

								{table.row?.[0] && (
									<div className='installInstructions-row border-t-2 border-t-primary'>
										{table.row.map((row, index) => (
											<div
												key={`row-${index}`}
												className={`installInstructions-col flex flex-row flex-wrap items-center p-2 xl:px-3 ${index % 2 ? 'bg-white' : 'bg-gray-5'}`}
											>
												{row.heading && (
													<div className='flex-12/12 lg:flex-1'>
														<div
															className='text-subtitle-2 [&_p]:flex [&_p]:items-center [&_span]:mr-2'
															dangerouslySetInnerHTML={{ __html: row.heading }}
														/>
													</div>
												)}

												{renderTableColumn(row.english?.[0])}
												{renderTableColumn(row.spanish?.[0])}
												{renderTableColumn(row.french?.[0])}
											</div>
										))}
									</div>
								)}
							</div>
						))}
				</Column>
			</Row>
		</div>
	);
};

InstallInstructions.propTypes = {
	data: PropTypes.object,
	className: PropTypes.string,
};

export default InstallInstructions;
